import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/a38c76d0530b8533d20cea3373fa0a6e.jpg"
          alt="夜の都市背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>
      
      <div className="relative z-10 container mx-auto px-4 py-32 text-center text-white w-full">
        <div className="inline-flex items-center gap-4 bg-teal-500 px-8 py-4 rounded-full mb-10 shadow-xl">
          <i className="ri-translate-2 text-white text-4xl"></i>
          <span className="text-3xl font-bold">{t('chineseSupport')}</span>
        </div>

        <p className="text-2xl mb-12 opacity-90 max-w-3xl mx-auto leading-relaxed">
          {t('description')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a 
            href="#contact" 
            className="relative bg-gradient-to-r from-amber-400 to-orange-500 text-white px-10 py-5 rounded-full text-xl font-bold hover:from-amber-500 hover:to-orange-600 transition-all shadow-[0_8px_30px_rgba(251,146,60,0.5)] hover:shadow-[0_12px_40px_rgba(251,146,60,0.7)] hover:-translate-y-1 whitespace-nowrap flex items-center gap-2 cursor-pointer"
          >
            {t('bookConsultation')}
            <i className="ri-calendar-check-line"></i>
          </a>
          <a 
            href="#services" 
            className="border-2 border-white text-white px-10 py-5 rounded-full text-xl font-medium hover:bg-white hover:text-slate-900 transition-all hover:-translate-y-1 whitespace-nowrap flex items-center gap-2 cursor-pointer"
          >
            {t('serviceDetails')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-translate-2 text-white text-3xl"></i>
            </div>
            <h3 className="font-bold text-xl mb-2">{t('feature1Title')}</h3>
            <p className="text-base text-slate-300">{t('feature1Desc')}</p>
          </div>
          
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-white text-3xl"></i>
            </div>
            <h3 className="font-bold text-xl mb-2">{t('feature2Title')}</h3>
            <p className="text-base text-slate-300">{t('feature2Desc')}</p>
          </div>
          
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-white text-3xl"></i>
            </div>
            <h3 className="font-bold text-xl mb-2">{t('feature3Title')}</h3>
            <p className="text-base text-slate-300">{t('feature3Desc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
